import { workbenchStore } from '~/lib/stores/workbench';
import { WORK_DIR } from '~/utils/constants';

export function normalizedFilePath(path: string): string {
  let normalizedPath = path;

  if (normalizedPath.startsWith(WORK_DIR)) {
    normalizedPath = path.replace(WORK_DIR, '');
  }

  if (normalizedPath.startsWith('/')) {
    normalizedPath = normalizedPath.slice(1);
  }

  return normalizedPath;
}

/** Open the code viewer focused on this file — streaming if it's still being
 *  written, or the finished file if it already landed. */
export function openFileInWorkbench(filePath: string): void {
  const normalized = normalizedFilePath(filePath);
  workbenchStore.openTool('code');
  workbenchStore.setSelectedFile(`${WORK_DIR}/${normalized}`);
}
